import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';
import md5 from 'md5';

import OnStock from './OnStock';
import Price from '../price/Price';
import OutOfStock from './OutOfStock';
import PriceIsNotFinal from './PriceIsNotFinal';
import PriceOnRequest from './PriceOnRequest';

import { addItem, updateItem, deleteItem } from '../../actions/basket-actions';
import { ga4TrackBasketItems } from '../../core/utils';

const MIN_VALUE_FOR_TEXT_INPUT = 9;

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class Product extends React.Component {

    state = {
        qtyInput: this.props.qty,
        timer: null
    }

    componentWillReceiveProps(nextProps) {
        const {qty} = nextProps;
        this.setState({
            qtyInput: !qty ? 0 : qty
        });
    }

    decreaseQty = () => {
        const {props: {updateItem, deleteItem, qty, product: {catalogNumber}}} = this;
        const nextQty = parseInt(qty) - 1;
        
        if (nextQty > 0) {
            updateItem(catalogNumber, nextQty);
            ga4TrackBasketItems( this.props.product, qty, nextQty );
        } else {
            ga4TrackBasketItems( this.props.product, qty, 0 );
            deleteItem(catalogNumber);
        }
    }

    increaseQty = () => {
        const {props: {updateItem, qty, product: {catalogNumber}}} = this;
        const nextQty = parseInt(qty) + 1;
        ga4TrackBasketItems( this.props.product, qty, nextQty );
        updateItem(catalogNumber, nextQty);
    }

    handleInputChange = (e) => {
        const {state: {timer}, triggerChange} = this;
        clearTimeout(timer);

        this.setState({
            qtyInput: e.currentTarget.value >= 0 ? parseInt( e.currentTarget.value ) : 0,
            timer: setTimeout(triggerChange, WAIT_INTERVAL)
        });
    }

    handleInputKeyDown = (e) => {
        const {triggerChange} = this;

        if (e.keyCode === ENTER_KEY) {
            triggerChange();
        }
    }

    triggerChange = () => {
        const {props: {updateItem, deleteItem, qty, product: {catalogNumber}}, state: {qtyInput}} = this;
        
       
        //the user erased content and will update the qty
        if( qtyInput === ""){
            return;
        }
        
        const newQty = qtyInput;

        if (newQty > 0) {
            ga4TrackBasketItems( this.props.product, qty, newQty );
            updateItem(catalogNumber, newQty);            
        } else {
            ga4TrackBasketItems( this.props.product, qty, 0 );
            deleteItem(catalogNumber);
        }
    }

    addBasketItem = () => {
        const {props: {addItem, product: {catalogNumber}}} = this;
        const nextQty = 1;        
        ga4TrackBasketItems( this.props.product, 0, nextQty );
        addItem(catalogNumber, nextQty);        
    }

    renderBasketControls = ( ) => {
        const {props: {isForDetail, handleShowVariants, addItem, qty, product: {catalogNumber, variantsProductArr}, basket: {items}}, state: {qtyInput},
            addBasketItem, decreaseQty, increaseQty, handleInputChange, handleInputKeyDown} = this;

        if (isForDetail || variantsProductArr.length === 0) {
            if (qty === 0) {
                return <a className={`btn ${isForDetail ? 'btn-lg' : 'btn-sm'} btn-basket add`} onClick={addBasketItem}>
                    { this.props.t( 'product.addToBasket' ) }
                </a>;
            }

            return (<React.Fragment>
                
                <a className="btn-basket minus" onClick={decreaseQty}>
                    <i className="glyphicon glyphicon-minus"></i>
                </a> 
                <div className="qty">
                    <input type="number" value={qtyInput} 
                           onChange={handleInputChange} 
                           onKeyDown={handleInputKeyDown} 
                           />
                </div>
                <a className={`btn-basket plus`} onClick={increaseQty}> 
                    <i className="glyphicon glyphicon-plus"></i>
                </a>                    
            </React.Fragment>
                    );
            
        }

        return <a className="btn btn-sm btn-basket add" onClick={e => handleShowVariants(catalogNumber) }>
            { this.props.t( 'product.displayVariants' ) }
        </a>;

    }

    renderStockQty = () => {
        const {props: {product: {stockQty}}} = this;

        if (!stockQty || stockQty == 0) {
            return <OutOfStock />;
        }

        return <OnStock stockQty={stockQty} />;
    }

    renderProductDetail = () => {
        const {props: {product: {catalogNumber, stockQty, variantsProductArr}}, renderStockQty} = this;

        if (variantsProductArr.length === 0) {
            return (
                <React.Fragment>
                    { this.props.t( 'product.catalogNumber' ) } {catalogNumber} {renderStockQty()}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                { this.props.t( 'product.cntVariants' ) } {variantsProductArr.length}
            </React.Fragment>
        );

    }

    renderProductPrice = () => {
        const {props: {isForBasket, product: {price, priceWithVat, priceCZKWithVat, duelId, variantsProductArr}}} = this;

        if (!priceWithVat) {
            return <PriceOnRequest />;
        }

        //cena je finalni
        if (duelId) {
            return <span className="priceSingleRow">
                <Price 
                    valueEUR={priceWithVat} 
                    valueCZK={priceCZKWithVat} 
                /> s DPH {isForBasket && '/ ks'}
            </span>;
        }

        if (variantsProductArr.length !== 0) {
            const minPriceWithVat = variantsProductArr.reduce((min, p) => p.priceWithVat < min ? p.priceWithVat : min, variantsProductArr[0].priceWithVat);
            const minPriceCZKWithVat = variantsProductArr.reduce((min, p) => p.priceCZKWithVat < min ? p.priceCZKWithVat : min, variantsProductArr[0].priceCZKWithVat);
            return <span className="priceSingleRow">
                od <Price valueEUR={minPriceWithVat} valueCZK={minPriceCZKWithVat} /> s DPH {isForBasket && '/ ks'}
            </span>;
        }

        return  (<React.Fragment>
                <Price 
                    valueEUR={priceWithVat} 
                    valueCZK={priceCZKWithVat} 
                /> s DPH {isForBasket && '/ ks'} 
                <br/> 
				<PriceIsNotFinal />
         </React.Fragment>);
    }
    
    renderProductTotalPrice = () => {
        const {state: {qtyInput}, props: { product: {price, priceWithVat, priceCZKWithVat}}} = this;

        if (!price) {
            return <React.Fragment>&nbsp;</React.Fragment>;
        }
         
        return (<span className="priceSingleRow">
            <Price valueEUR={(priceWithVat).toFixed(2) * qtyInput} 
                   valueCZK={(priceCZKWithVat).toFixed(2) * qtyInput}
            /> s DPH<br/>
       </span>);
    }

    renderProductName = () => {
        const {props: {product: {productUrl, productName, groupName, variantsProductArr}}} = this;

        if (variantsProductArr.length !== 0) {
            return <a href={productUrl}>{groupName}</a>;
        }

        return <a href={productUrl}>{productName}</a>;

    }
    
    renderProductRemove = () => {
        const {props: {deleteItem, qty, product: {catalogNumber}}} = this;
        
         return (<span className="priceSingleRow">
             <a href="#" onClick={() => { deleteItem( catalogNumber ); ga4TrackBasketItems( this.props.product, qty, 0 );}}>
                 <i className="glyphicon glyphicon-remove"></i>
             </a> 
         </span>);
    }

    renderBasic = () => {
        const {renderBasketControls, renderProductDetail, renderProductPrice, renderProductName} = this;
        return (
                <li>
                    <div className="product">
                        <div className="detail">
                            {renderProductName()}
                            <br/> 
                            {renderProductDetail()}
                        </div>
                        <div className="basket-controls">
                            {renderBasketControls()}
                        </div>
                        <div className="price-info">
                            {renderProductPrice()}                           
                        </div>
                        <div className="clearfix"></div>
                    </div>                            
                </li>

                );
    }
	
	renderForDetail = () => {
		const {renderBasketControls} = this;
	
		return (
            <div className="basket-controls">
                {renderBasketControls()}
            </div>
        );
	}

    renderForBasket = () => {
        
        const {props: {product: {catalogNumber}}, renderBasketControls, renderProductDetail, 
                renderProductPrice, renderProductTotalPrice, renderProductName, renderProductRemove} = this;
        return (
                <li data-md5={md5(catalogNumber)}>
                    <div className="product basket" >
                        <div className="detail">
                            {renderProductName()}
                            <br/> 
                            {renderProductDetail()}
                        </div>
                        <div className="price-item">
                            {renderProductPrice()} 
                        </div>
                        <div className="basket-controls">
                            {renderBasketControls()}
                        </div>
                        <div className="price-info hidden-xs">
                            {renderProductTotalPrice()}                           
                        </div>
                        <div className="remove-item">
                            {renderProductRemove()} 
                        </div>
                        <div className="clearfix"></div>
                    </div>                            
                </li>

                );
    }

    render() {
        const {props: {isForBasket, isForDetail}, renderForBasket, renderForDetail, renderBasic} = this;

        if (isForBasket) {
            return renderForBasket();
        }
		
		if (isForDetail) {
            return renderForDetail();
        }

        return renderBasic();
    }

}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateItem,
    deleteItem,
    addItem
}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)( withTranslation()( Product) );
